import { useMemo } from 'react';

import { useFlag } from '../../../services/launchDarkly';
import { useStores } from '../../../stores/useStores';
import type { ChallengeWidgetDataType, WidgetEntry } from '../types';

export function useChallengeWidgets() {
  const { challengesStore } = useStores();
  const { challengesLength } = challengesStore;
  const challengesFF = useFlag('challenges_feat', false);

  const challengeWidgets: ChallengeWidgetDataType[] = useMemo(() => {
    if (!challengesFF || !challengesLength) {
      return [];
    }
    return [
      {
        key: 'challenges',
        dataTestId: 'challenge-widget',
      },
    ];
  }, [challengesFF, challengesLength]);

  return useMemo(
    () => challengeWidgets.map((data): WidgetEntry<'challenge'> => ({ data, type: 'challenge', id: data.key })),
    [challengeWidgets],
  );
}
